import React, { useState, useEffect } from "react";
import { CrudFilters } from "@pankod/refine-core";
import { Typography } from 'antd';

import {
    Table,
    useTable,
    Space,
    ShowButton,
    DateField,
    Tag,
    Card,
    Row,
    Col,
    Icons,
    Form,
    Input,
    Button,
    FormProps,
    Select,
} from "@pankod/refine-antd";
import { getQueryParam, setQueryParam } from "../../../../../utility/queryParams";
import { AcceptTransBnkRequestModal } from "../modal/accept-trans-bnk-request.modal";
import { RejectTransBnkRequestModal } from "../modal/reject-trans-bnk-request.modal";
import { BankUserAuthorizationStatus, ConnectedBankingStatus } from "../../../../../interfaces/integrator";

const { Text } = Typography;

export const ListingCbPageTable: React.FC<{
    companyDetail: string,
    cbStatus: ConnectedBankingStatus,
    refreshTableData: any,
}> = ({ companyDetail, cbStatus, refreshTableData }) => {

    let [id, setID] = useState();
    let [refetchOnboardedTable, setRefetchOnboardedTable] = useState(false);
    let [refetchPendingTable, setRefetchPendingTable] = useState(false);

    let [status, setStatus] = useState<ConnectedBankingStatus>(cbStatus);
    let [companyId, setCompanyId] = useState<string>(companyDetail);

    const { tableProps: pendingOnboardingRequest } = useTable<any>({
        dataProviderName: "grapghQl",
        resource: 'getConnectedBankingOnboardingRequestForCompany',
        metaData: {
            companyId,
            tableRefetch: refetchPendingTable,
        },
    });

    const { tableProps: OnboardedCompanies, searchFormProps } = useTable<any>({
        dataProviderName: "grapghQl",
        resource: 'allConnectedBankingAccountsViaInternalPortalPaginated',
        metaData: {
            filters: {
                id: id,
                companyId,
                status: ConnectedBankingStatus[status],
            },
            refetchTable: refetchOnboardedTable
        },
        onSearch: (params: any) => {
            const filters: CrudFilters = [];
            const { status, companyId, id } = params;
            if (id) {
                setID(id);
                setQueryParam('id', id)
            }
            if (status) {
                setStatus(status);
                setQueryParam('status', status)
            }
            if (companyId) {
                setCompanyId(companyId);
                setQueryParam('companyId', companyId);
            }

            return filters;
        },
    });

    useEffect(() => {
        const companyId = getQueryParam("companyId");
        if (companyId) {
            searchFormProps?.form?.setFieldsValue({companyId})
        }
    }, [companyDetail]);

    let onboardedCompanyTotalPage
    if (OnboardedCompanies?.pagination) {
        let totalItem: number = OnboardedCompanies?.pagination.total || 0
        let pageSize: number = OnboardedCompanies?.pagination.pageSize || 0
        onboardedCompanyTotalPage = Math.ceil(totalItem / pageSize)
    }

    let pendingOnboardingRequestTablePage
    if (pendingOnboardingRequest?.pagination) {
        let totalItem: number = pendingOnboardingRequest?.pagination.total || 0
        let pageSize: number = pendingOnboardingRequest?.pagination.pageSize || 0
        pendingOnboardingRequestTablePage = Math.ceil(totalItem / pageSize)
    }

    const refetchTableProps = (value: boolean) => {
        if(value) {
            setRefetchOnboardedTable(true)
        }
        setRefetchPendingTable(true);
    }

    useEffect(() => {
        if(refreshTableData) {
            refetchTableProps(true);
        }
    }, [refreshTableData]);

    useEffect(() => {
        if(refetchPendingTable) {
            setRefetchPendingTable(false);
        }
    }, [refetchPendingTable]);

    useEffect(() => {
        if(refetchOnboardedTable) {
            setRefetchOnboardedTable(false);
        }
    }, [refetchOnboardedTable]);

    return (
        <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
                <Card title="Filters">
                    <Filter formProps={searchFormProps} />
                </Card>
            </Col>
            <Col lg={24} xs={24}>
                <Text>Connected Banking</Text>
                <Table {...OnboardedCompanies} rowKey="id">
                    <Table.Column
                        dataIndex="id"
                        title="Bank ID"
                        key="bankId"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <p>
                                    {record?.id}
                                </p>
                            </Space>

                        )}
                    />
                    <Table.Column
                        dataIndex="integratorName"
                        key="integratorName"
                        title="Integrator Name"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <h4>
                                    {record?.authorization?.bankIntegration?.bankServiceProvider?.name}
                                </h4>
                            </Space>

                        )}
                    />
                    <Table.Column
                        dataIndex="accountId"
                        title="Account ID"
                        key="accountId"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <h4>
                                    {record?.maskedAccountNo}
                                </h4>
                            </Space>

                        )}
                    />
                    <Table.Column
                        dataIndex="accountId"
                        title="Account ID"
                        key="accountId"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <h4>
                                    {record?.balance || 'N/A'}
                                </h4>
                            </Space>

                        )}
                    />
                    <Table.Column
                        title="Brand Name"
                        key="brandName"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <h4>
                                    {record?.authorization?.authorizingUserCompany?.brandName || 'N/A'}
                                </h4>
                            </Space>

                        )}
                    />
                    <Table.Column
                        dataIndex="Banking Status"
                        title="Banking Status"
                        render={(_, record: any) => {
                            const value = record?.authorization.status;
                            let color;
                            switch (value) {
                                case ConnectedBankingStatus.GRANTED:
                                    color = "green";
                                    break;
                                case ConnectedBankingStatus.REQUEST_FAILED || ConnectedBankingStatus.REJECTED:
                                    color = "red";
                                    break;
                                case ConnectedBankingStatus.REVOKED || ConnectedBankingStatus.REQUEST_TO_BE_SENT:
                                    color = "blue";
                                    break;
                                default:
                                    color = "";
                            }
                            return <Tag color={color}>{value}</Tag>;
                        }}
                    />
                    <Table.Column
                        dataIndex="createdAt"
                        key="createdAt"
                        title="Created At"
                        render={(value) => <DateField value={value} format="LLL" />}
                    />
                    <Table.Column
                        title="Actions"
                        dataIndex="actions"
                        key="actions"
                        render={(_, record:any) => (
                            <Space>
                                <ShowButton
                                    size="small"
                                    recordItemId={record?.id}
                                />
                            </Space>
                        )}
                    />
                </Table>
                {
                    (OnboardedCompanies?.dataSource && OnboardedCompanies?.pagination) ? <span>
                        Showing {OnboardedCompanies?.pagination?.current} - {onboardedCompanyTotalPage} of <strong>{OnboardedCompanies?.pagination.total}</strong> Records
                    </span> : ''
                }
            </Col>
            <Col lg={24} xs={24}>
                <h3>Pending TransBnk Requests</h3>
                <Table {...pendingOnboardingRequest} rowKey="id">
                    <Table.Column
                        dataIndex="id"
                        title="ID"
                        key="id"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <p>
                                    {record?.bankUserAuth?.id}
                                </p>
                            </Space>

                        )}
                    />
                    <Table.Column
                        dataIndex="accountNumber"
                        title="Account Number"
                        key="accountNumber"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <p>
                                    {record?.bankUserAuth?.bankAccountValidationRequest?.accountNumber}
                                </p>
                            </Space>

                        )}
                    />
                    <Table.Column
                        dataIndex="ifsc"
                        title="Ifsc"
                        key="ifsc"
                        render={(_, record: any) => (
                            <Space align='baseline' direction="vertical">
                                <p>
                                    {record?.bankUserAuth?.bankAccountValidationRequest?.ifsc}
                                </p>
                            </Space>

                        )}
                    />
                    <Table.Column
                        dataIndex="status"
                        title="Status"
                        key="status"
                        render={(_, record: any) => {
                            let color;
                            let value = record?.bankUserAuth?.status;
                            switch (value) {
                                case BankUserAuthorizationStatus.PENDING:
                                    color = "blue";
                                    break;
                                case BankUserAuthorizationStatus.GRANTED:
                                    color = "cyan";
                                    break;
                                case BankUserAuthorizationStatus.REVOKED:
                                    color = "red";
                                    break;
                                case BankUserAuthorizationStatus.REQUEST_FAILED:
                                    color = "green";
                                    break;
                                default:
                                    color = "green";
                            }
                            return <Tag color={color}>{value}</Tag>;

                        }}
                    />
                    <Table.Column
                        dataIndex="action"
                        title="Action"
                        key="action"
                        render={(_, record: any) => (
                            <Space>
                                <AcceptTransBnkRequestModal recordDetails={record.bankUserAuth} refetchTableProps={refetchTableProps}  />
                                <RejectTransBnkRequestModal bankUserAuthorizationRequestId={record.bankUserAuth?.id} refetchTableProps={refetchTableProps} />
                            </Space>
                        )}
                    />
                </Table>
                {
                    (pendingOnboardingRequest?.dataSource && pendingOnboardingRequest?.pagination) ? <span>
                        Showing {pendingOnboardingRequest?.pagination?.current} - {pendingOnboardingRequestTablePage} of <strong>{pendingOnboardingRequest?.pagination.total}</strong> Records
                    </span> : ''
                }
            </Col>
        </Row>
    );
};


const Filter: React.FC<{ formProps: FormProps }> = ({ formProps }) => {
    return (
        <Form layout="vertical" {...formProps}>
            <Row gutter={[16, 16]}>
                <Col lg={3} xs={3}>
                    <Form.Item label="Ids" name="id">
                        <Input
                            placeholder="ID"
                            prefix={<Icons.SearchOutlined />}
                        />
                    </Form.Item>
                </Col>
                <Col lg={6} xs={6}>
                    <Form.Item hidden={true} label="Table Refetch field" name="tableRefetch">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Company Id" name="companyId">
                        <Input
                            placeholder="Company Id"
                            prefix={<Icons.SearchOutlined />}
                        />
                    </Form.Item>
                </Col>
                <Col lg={3} xs={3}>
                    <Form.Item label="Status" name="status">
                        <Select
                            disabled={true}
                            onChange={(e: any) => {
                                formProps.form?.setFieldsValue({ status: e });
                            }}
                            defaultValue={ConnectedBankingStatus.GRANTED}
                            options={Object.keys(ConnectedBankingStatus).map((d: any,index) => ({
                                value: index,
                                label: d,
                            }))}
                        />
                    </Form.Item>
                </Col>
                <Col lg={6} xs={24}>
                    <Form.Item>
                        <br />
                        <Button htmlType="submit" type="primary">
                            Filter
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}
